import { Actions, createEffect, ofType } from '@ngrx/effects';
import { PolicyService } from './../services/policy.service';
import { Injectable, inject } from '@angular/core';
import { PolicyActions, PolicyResetActions } from '../actions/policy.action';
import { catchError, map, of, switchMap } from 'rxjs';
import { HttpError, HttpResponse } from '@shared/utils/models/http.model';
import { PolicyData } from '@core/utils/models/policy.model';

@Injectable()
export class PolicyEffects {
  private readonly policyService = inject(PolicyService);
  private readonly actions$ = inject(Actions);

  getUserAgreement$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PolicyActions.getUserAgreement, PolicyResetActions.cancelPolicyActions),
      switchMap((action) =>
        action.type === PolicyResetActions.cancelPolicyActions.type
          ? of(PolicyResetActions.cancelPolicyActionsSuccess())
          : this.policyService.getUserAgreement().pipe(
              map((response: HttpResponse<PolicyData>) =>
                PolicyActions.getUserAgreementSuccess({ data: response.message })
              ),
              catchError((error: HttpError) => of(PolicyActions.getUserAgreementFailure({ error })))
            )
      )
    );
  });

  getTermsOfUse$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PolicyActions.getTermsOfUse, PolicyResetActions.cancelPolicyActions),
      switchMap((action) =>
        action.type === PolicyResetActions.cancelPolicyActions.type
          ? of(PolicyResetActions.cancelPolicyActionsSuccess())
          : this.policyService.getTermsOfUse().pipe(
              map((response: HttpResponse<PolicyData>) =>
                PolicyActions.getTermsOfUseSuccess({ data: response.message })
              ),
              catchError((error: HttpError) => of(PolicyActions.getTermsOfUseFailure({ error })))
            )
      )
    );
  });

  getPrivacyPolicy$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(PolicyActions.getPrivacyPolicy, PolicyResetActions.cancelPolicyActions),
      switchMap((action) =>
        action.type === PolicyResetActions.cancelPolicyActions.type
          ? of(PolicyResetActions.cancelPolicyActionsSuccess())
          : this.policyService.getPrivacyPolicy().pipe(
              map((response: HttpResponse<PolicyData>) =>
                PolicyActions.getPrivacyPolicySuccess({ data: response.message })
              ),
              catchError((error: HttpError) => of(PolicyActions.getPrivacyPolicyFailure({ error })))
            )
      )
    );
  });
}
